/**
 * {TestModeTestAutoFillData}
 * @constructor
 */
let TestModeTestAutoFillData = function () {
  let self = this;

  self.generated = false;

  /**
   * hasNoOrderDataAttribute
   * @param property
   * @param order
   * @returns {boolean}
   */
  let hasNoOrderDataAttribute = function (property, order) {
    return !order || !order.attributes || !order.attributes[property];
  };

  /**
   * dateFormated
   * @type {*}
   */
  let dateFormated = {
    "dd/mm/yyyy": "25/12/1955",
    "mm/dd/yyyy": "12/25/1955",
    "YYYY-MM-DD": "1999-01-01", // CAN
  };

  /**
   * getDateInput
   * @returns {string}
   */
  let getDateInput = function (order) {
    if (hasNoOrderDataAttribute("dateRules", order)) {
      return dateFormated["mm/dd/yyyy"];
    }

    if (order.attributes.dateRules.datePlaceholder) {
      return dateFormated[order.attributes.dateRules.datePlaceholder];
    }

    return dateFormated["mm/dd/yyyy"];
  };

  /**
   * getTaxIdInput
   * @param randomString
   * @param order
   * @returns {*}
   */
  let getTaxIdInput = function (randomString, order) {
    if (hasNoOrderDataAttribute("taxIdRules", order)) {
      return "";
    }

    // 15512 goes with the test date
    let taxId = "15512" + randomString;

    if (order.attributes.taxIdRules.taxIdRequiredLength) {
      taxId = taxId.substring(
        0,
        order.attributes.taxIdRules.taxIdRequiredLength
      );
    }

    if (order.attributes.taxIdRules.taxIdFilterRegEx) {
      let regEx = new RegExp(order.attributes.taxIdRules.taxIdFilterRegEx);

      let tempTaxId = regEx.exec(taxId);

      if (tempTaxId) {
        taxId = tempTaxId;
      }
    }

    return taxId;
  };

  /**
   *
   * @param randomString
   * @returns {string}
   */
  let getUsername = function (randomString) {
    let username = "test" + randomString;

    return username.substring(0, 13);
  };

  /**
   *
   */
  self.getTestData = function (params) {
    let order = params.order;

    let randomString = ("" + Math.random()).substring(2, 13);

    let postalCode = window.location.hostname.includes(".co.uk")
      ? "B98 9PB" //GBR
      : window.location.hostname.includes(".ca")
      ? "A1A 1A1" //CAN
      : 63108;

    let randomPhone = Math.floor(100000000 + Math.random() * 900000000);

    return {
      sponsorRcn: "4057510001",
      sponsorRcnAgain: "4057510001",
      primaryFirstName: "TestFirstñame" + randomString,
      primaryLastName: "TestLastñame" + randomString,
      email: "TestEmail" + randomString + "@example.com",
      username: getUsername(randomString),
      password: "testdata", //
      passwordAgain: "testdata", //
      primarySsn: getTaxIdInput(randomString, order),
      primaryDateOfBirth: getDateInput(order),
      secondaryDateOfBirth: getDateInput(order),
      daytimePhone: randomPhone,
      "shipAddress[nameLine]": "Johñ Smith" + randomString,
      "shipAddress[postalCode]": postalCode,
      "shipAddress[geoCode]": "265101270",
      "shipAddress[addressLine1]": randomString + " testviēw place",
      "shipAddress[state]": "MO",
      "shipAddress[phone]": randomPhone,
      "shipAddress[city]": "SAINT LOUIS",
      billAddressSame: true,
      acceptedTerms: true,
      mailingAddressAddressLine1: randomString + " testgaté làne Apt F26",
      mailingAddressPostalCode: postalCode,
      mailingAddressCity: "SAINT LOUIS",
      mailingAddressState: "string:MO",
      // 'creditCard[nameOnCard]': 'Test Test',
      // 'creditCard[cardNumber]': '4444444444444448',
      // 'creditCard[expirationMonth]': '11',
      // 'creditCard[expirationYear]': (new Date().getFullYear() + 1).toString(),
      // 'creditCard[verificationCode]': '123',
    };
  };
};

angular.module("testMode").factory("testModeTestAutoFillData", function () {
  return new TestModeTestAutoFillData();
});
